import { Controller } from '@hotwired/stimulus';

/**
 * double submit 방지 처리를 합니다.
 */
export default class extends Controller {
  preventDoubleSubmit(submitEvent) {
    const submitter = this.findSubmitter(submitEvent);
    this.disable(submitter);
  }

  findSubmitter(event) {
    if (event instanceof SubmitEvent) {
      return event.submitter;
    }
  }

  disable(submitter) {
    if (submitter == null) {
      return;
    }
    submitter.disabled = true;
    submitter.classList.add('cursor-progress');
    document.querySelector('BODY').classList.add('cursor-progress');
  }
}
